import React, { useState, useEffect, useMemo } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TableRow,
    Table,
    TableHead,
    TableBody,
    TableCell,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Card,
    Box,
    TableContainer,
    Paper,
    Typography,
    Grid,
    TextField,
    IconButton,
    InputAdornment,
    Tooltip,
    Chip,
    FormHelperText,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import TeacherService from "./Locality/Service/teacherService";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SchoolIcon from '@material-ui/icons/School';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Divider } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";

const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: { padding: theme.spacing(1) },
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#0f2d4d',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#6b7280',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    primaryBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#eef4ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1769d6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
    },
    filtersHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
        backgroundColor: '#fafbfc',
    },
    filtersBody: {
        padding: theme.spacing(2),
    },
    filterLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    applyBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
    },
    iconBtnOutlined: {
        border: '1px solid #e6eaf0',
        borderRadius: 8,
        padding: 7,
    },
    headCell: {
        backgroundColor: '#f4f6fa',
        color: '#46566b',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #e6eaf0',
        whiteSpace: 'nowrap',
    },
    classChip: {
        backgroundColor: '#eef4ff',
        color: '#1769d6',
        fontWeight: 600,
        height: 24,
    },
    sectionChip: {
        backgroundColor: '#f3efff',
        color: '#7c4dff',
        fontWeight: 600,
        height: 24,
    },
    statusActive: {
        backgroundColor: '#e6f7ed',
        color: '#1a9b54',
        fontWeight: 600,
        height: 24,
    },
    statusInactive: {
        backgroundColor: '#f4f6fa',
        color: '#9aa6b6',
        fontWeight: 600,
        height: 24,
    },
    tableStatusFooter: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid #eef1f5',
        backgroundColor: '#fafbfc',
    },
    addressExpandRow: {
        backgroundColor: '#f8fafc',
        '& td': {
            borderBottom: '1px solid #e6eaf0',
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
        },
    },
    addressExpandBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1, 1.5),
        borderRadius: 10,
        border: '1px solid #e6eaf0',
        backgroundColor: '#fff',
    },
    statusCountLabel: {
        fontSize: '0.8125rem',
        color: '#46566b',
        fontWeight: 600,
    },
    actionBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        fontSize: '0.75rem',
        padding: '4px 10px',
        minWidth: 0,
    },
    assignBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        border: 'none',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    transferBtn: {
        borderColor: '#1769d6',
        color: '#1769d6',
    },
    iconAction: {
        padding: 6,
        color: '#46566b',
        '&:hover': { backgroundColor: '#f1f5fb', color: '#1769d6' },
    },
    deleteIcon: {
        padding: 6,
        color: '#46566b',
        '&:hover': { backgroundColor: '#ffebee', color: '#c62828' },
    },
    dialogPaper: {
        borderRadius: 14,
        maxWidth: 340,
        width: '100%',
        margin: theme.spacing(2),
    },
    dialogPaperWide: {
        borderRadius: 14,
        maxWidth: 640,
        width: '95%',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
        backgroundColor: '#fafafa',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2, 2.5, 1.5),
    },
    infoBox: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5),
        backgroundColor: '#eef4ff',
        borderRadius: 10,
        border: '1px solid #d6e4ff',
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    sectionLabel: {
        display: 'block',
        fontWeight: 700,
        color: '#46566b',
        fontSize: '0.72rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: theme.spacing(1.25),
    },
    formSection: {
        marginBottom: theme.spacing(1.5),
    },
    formGrid: {
        width: '100%',
        margin: 0,
    },
    formGridItem: {
        paddingTop: `${theme.spacing(1)}px !important`,
        paddingBottom: `${theme.spacing(1)}px !important`,
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
        backgroundColor: '#fafafa',
        gap: theme.spacing(1),
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
}));

const isTeacherActive = (teacher) =>
    teacher.status === 'active' || teacher.status === true || teacher.status == null;

export default function Teacher() {
    const classes = useStyles();
    const userDetails = useMemo(
        () => JSON.parse(localStorage.getItem("userDetail") || "{}"),
        []
    );
    const isSchoolAdmin = userDetails.role === 'SCHOOLE';
    const tableHeaders = useMemo(() => {
        const headers = ['Teacher Name', 'Class', 'Section', 'View', 'Status', 'Assign Class', 'Edit', 'Delete', 'Transfer'];
        if (isSchoolAdmin) headers.push('Reset Password');
        return headers;
    }, [isSchoolAdmin]);
    const [teacherList, setTeacherList] = useState([]);
    const [age, setAge] = React.useState('');
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [teacher, setTeacher] = useState({
        teacherName: '',
         email: '',
        password: '',
        qualification: '',
        address: '',
        mobileNumber: '',
        classId: '',
        sectionId: '',
        status: 'active',
    })
    
               var [searchClassId, setSearchClassId] = useState("");
    
     const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [transferOpen, setTransferOpen] = useState(false);
    const [transferFromTeacher, setTransferFromTeacher] = useState(null);
    const [transferClassId, setTransferClassId] = useState('');
    const [transferToTeacherId, setTransferToTeacherId] = useState('');
    // State for assigning multiple classes/sections to a teacher
    const [assignOpen, setAssignOpen] = useState(false);
    const [assignTeacher, setAssignTeacher] = useState(null);
    const [assignClassId, setAssignClassId] = useState('');
    const [assignSectionIds, setAssignSectionIds] = useState([]);
    const [assignSectionList, setAssignSectionList] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [assignEditingIndex, setAssignEditingIndex] = useState(null);
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
    const [resetPasswordTeacher, setResetPasswordTeacher] = useState(null);
    const [resetPasswordValue, setResetPasswordValue] = useState('');
    const [resetPasswordError, setResetPasswordError] = useState('');
    const [resetPasswordSuccess, setResetPasswordSuccess] = useState('');
    const [resetPasswordSaving, setResetPasswordSaving] = useState(false);
    const [resetShowPassword, setResetShowPassword] = useState(false);
    const [expandedAddressId, setExpandedAddressId] = useState(null);
    const [noteOpen, setNoteOpen] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [pg, setPg] = useState(0);
    const [rpg, setRpg] = useState(10);
    const validationSchema = Yup.object().shape({
        teacherName: Yup.string().required('Teacher name is required'),
        classId: Yup.string(),
        email: Yup.string(),
        password: Yup.string().when('_id', {
            is: (val) => !!val,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.required('Password is required'),
        }),
        qualification: Yup.string(),
        address: Yup.string(),
        status: Yup.string()
            .oneOf(['active', 'inactive'], 'Status must be Active or Inactive')
            .required('Status is required'),
        mobileNumber: Yup.string().required('Mobile number is required')
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(10, 'Must be exactly 10 digits')
            .max(10, 'Must be exactly 10 digits'),
    });
    useEffect(() => {
        getTeacherList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setTeacher({
                teacherName: '',
                 email: '',
                password: '',
                qualification: '',
                address: '',
                mobileNumber: '',
                classId: '',
                status: 'active',
            })
        }

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => {
                // de-duplicate by className just in case
                const list = Array.isArray(res) ? res : [];
                const map = new Map();
                for (const item of list) {
                    const key = String(item?.className || "").trim().toLowerCase();
                    if (!key) continue;
                    if (!map.has(key)) map.set(key, item);
                }
                const unique = Array.from(map.values()).sort((a, b) =>
                    String(a?.className || "").localeCompare(String(b?.className || ""))
                );
                setAddClassList(unique);
            })
            .catch(() => {
                setAddClassList([]);
            });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };
    // Load sections for Assign Class dialog based on selected class
    const getAssignSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setAssignSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setAssignSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setAssignSectionList([]);
            });
    };
    // const getStudentList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     StudentService.getAllStudent(userDetails.schooleId).then((res) => {
    //      const mapResult =   res.map((student)=>{
    //             return {...student,fullName:`${student.firstName} ${student.lastName} `}
    //         })
    //         setStudentList(mapResult);
    //     }).catch((err) => {
    //         console.error("Error fetching student list:", err);
    //     });
    // };
    const getTeacherList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        TeacherService.getAllTeacher(userDetails.schooleId).then((res) => {
            const mapResult =   res.map((teacher)=>{
                return {...teacher}
            })
            setTeacherList(mapResult);
            
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      
        const keys = {
            'classId': searchClassId, 
        }
        TeacherService.findTeachertList(keys).then((res) => {
          
            const mapResult =   res.map((teacher)=>{
                return {...teacher}
            })
            setTeacherList(mapResult);
            // setStudentList(res);
        }).catch((err) => {
            console.error(err)
            // setError(err.message);
        });

    };
    const editTeacher = (rowTeacher) => {
        const teacherForForm = {
            ...rowTeacher,
            classId: rowTeacher.classId ? (rowTeacher.classId._id || rowTeacher.classId) : '',
            sectionId: rowTeacher.sectionId ? (rowTeacher.sectionId._id || rowTeacher.sectionId) : '',
            status: (rowTeacher.status === true || rowTeacher.status === 'active') ? 'active' : 'inactive',
        };
        if (teacherForForm.classId) {
            getSectionListByClass(teacherForForm.classId);
        } else {
            setSectionList([]);
        }
        setTeacher(teacherForForm);
        handleOpen(false);
        setIsEditMode(true);
    }
    const deleteTeacher = (teacherdelete) => {
        if (teacherdelete) {
            const teacherName = teacherdelete.teacherName || 'this teacher';
            const confirmMessage = `Are you sure you want to delete "${teacherName}"?\n\nThis action cannot be undone. All associated data will be permanently removed.`;
            
            if (window.confirm(confirmMessage)) {
                TeacherService.deleteTeacher(teacherdelete).then((res) => {
                    getTeacherList();
                    alert(`Teacher "${teacherName}" has been deleted successfully.`);
                }).catch((err) => {
                    alert(err?.response?.data?.message || `Failed to delete teacher "${teacherName}". Please try again.`);
                });
            }
        }
    };

    const openResetPasswordDialog = (rowTeacher) => {
        if (!rowTeacher?._id) return;
        setResetPasswordTeacher(rowTeacher);
        setResetPasswordValue('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
        setResetPasswordOpen(true);
    };

    const closeResetPasswordDialog = () => {
        setResetPasswordOpen(false);
        setResetPasswordTeacher(null);
        setResetPasswordValue('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
    };

    const handleResetPasswordSubmit = () => {
        if (!resetPasswordTeacher?._id) return;

        const password = resetPasswordValue.trim();
        if (password.length < 6) {
            setResetPasswordError('Password must be at least 6 characters.');
            return;
        }

        setResetPasswordSaving(true);
        setResetPasswordError('');
        TeacherService.resetTeacherPassword(resetPasswordTeacher._id, { password })
            .then((res) => {
                const teacherName = resetPasswordTeacher.teacherName || 'Teacher';
                setResetPasswordSuccess(
                    res?.data?.message || `Password updated successfully for "${teacherName}".`
                );
            })
            .catch((err) => {
                setResetPasswordError(
                    err?.response?.data?.message || 'Failed to reset password. Please try again.'
                );
            })
            .finally(() => setResetPasswordSaving(false));
    };

    // ----- Assign Class & Section (additionalClassAndSection) -----
    const openAssignClassDialog = (rowTeacher) => {
        const existing = Array.isArray(rowTeacher.additionalClassAndSection)
            ? rowTeacher.additionalClassAndSection
            : [];

        const normalizedAssignments = existing.map((item) => {
            const cls = item && item.class ? item.class : {};
            const classId =
                (cls.classId && cls.classId._id) ||
                cls.classId ||
                (cls._id || "");
            const className = cls.className || (cls.classId && cls.classId.className) || "";

            const sections = Array.isArray(item.sectionId)
                ? item.sectionId.map((sec) => {
                    const sectionId =
                        (sec && sec.sectionId && sec.sectionId._id) ||
                        (sec && sec.sectionId) ||
                        (sec && sec._id) ||
                        "";
                    const sectionName =
                        (sec && sec.sectionName) ||
                        (sec && sec.sectionId && sec.sectionId.sectionName) ||
                        "";
                    return {
                        sectionId,
                        sectionName,
                    };
                  }).filter((s) => s.sectionId)
                : [];

            return {
                class: {
                    classId,
                    className,
                },
                sectionId: sections,
            };
        });

        setAssignTeacher(rowTeacher);
        setAssignments(normalizedAssignments);
        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
        setAssignOpen(true);
    };

    const handleAssignClose = () => {
        setAssignOpen(false);
        setAssignTeacher(null);
        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
    };

    const handleAssignClassChange = (event) => {
        const value = event.target.value;
        setAssignClassId(value);
        setAssignSectionIds([]);
        getAssignSectionListByClass(value);
    };

    const handleAssignSectionChange = (event) => {
        const value = event.target.value;
        setAssignSectionIds(typeof value === 'string' ? value.split(',') : value);
    };

    const handleAddOrUpdateAssignment = () => {
        if (!assignClassId) {
            alert("Please select a class before assigning.");
            return;
        }
        const selectedClass = addClassList.find((c) => (c._id === assignClassId));
        const className = selectedClass ? selectedClass.className : "";

        const nextAssignment = {
            class: {
                classId: assignClassId,
                className,
            },
            sectionId: (assignSectionIds || []).map((id) => {
                const sec = assignSectionList.find((s) => s._id === id);
                return {
                    sectionId: id,
                    sectionName: (sec && sec.sectionName) || "",
                };
            }),
        };

        setAssignments((prev) => {
            const copy = [...prev];
            if (assignEditingIndex != null && assignEditingIndex > -1 && assignEditingIndex < copy.length) {
                copy[assignEditingIndex] = nextAssignment;
            } else {
                // prevent exact duplicate class+sections combination
                const exists = copy.some((item) => {
                    const sameClass = String(item.class.classId) === String(nextAssignment.class.classId);
                    const existingSecIds = (item.sectionId || []).map((s) => String(s.sectionId)).sort().join(',');
                    const nextSecIds = (nextAssignment.sectionId || []).map((s) => String(s.sectionId)).sort().join(',');
                    return sameClass && existingSecIds === nextSecIds;
                });
                if (!exists) {
                    copy.push(nextAssignment);
                }
            }
            return copy;
        });

        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
    };

    const handleEditAssignment = (index) => {
        const item = assignments[index];
        if (!item) return;

        const classId = item.class && (item.class.classId || (item.class._id));
        setAssignClassId(classId || "");
        const secIds = Array.isArray(item.sectionId)
            ? item.sectionId.map((s) => s.sectionId || (s._id || ""))
            : [];
        setAssignSectionIds(secIds);
        if (classId) {
            getAssignSectionListByClass(classId);
        } else {
            setAssignSectionList([]);
        }
        setAssignEditingIndex(index);
    };

    const handleDeleteAssignment = (index) => {
        setAssignments((prev) => prev.filter((_, i) => i !== index));
    };

    const handleAssignSave = () => {
        if (!assignTeacher) {
            return;
        }
        TeacherService.updateAdditionalClassAndSection(assignTeacher._id, {
            additionalClassAndSection: assignments,
        })
            .then((res) => {
                handleAssignClose();
                getTeacherList();
                alert(res?.data?.message || "Additional classes/sections updated successfully.");
            })
            .catch((err) => {
                alert(
                    err?.response?.data?.message ||
                    "Failed to update additional classes/sections."
                );
            });
    };

    const openTransferPopup = (rowTeacher) => {
        const classId = rowTeacher.classId ? (rowTeacher.classId._id || rowTeacher.classId) : '';
        if (!classId) return;
        setTransferFromTeacher(rowTeacher);
        setTransferClassId(classId);
        setTransferToTeacherId('');
        setTransferOpen(true);
    };

    const handleTransferClose = () => {
        setTransferOpen(false);
        setTransferFromTeacher(null);
        setTransferClassId('');
        setTransferToTeacherId('');
    };

    const handleTransferSubmit = () => {
        if (!transferToTeacherId || !transferFromTeacher) return;
        TeacherService.transferTeacher({
            fromTeacherId: transferFromTeacher._id,
            toTeacherId: transferToTeacherId,
            classId: transferClassId,
        }).then((res) => {
            handleTransferClose();
            getTeacherList();
            alert(res?.data?.message || 'Transfer completed successfully.');
        }).catch((err) => {
            alert(err?.response?.data?.message || 'Failed to transfer teacher data.');
        });
    };

    const teachersWithoutClass = teacherList.filter((t) => {
        const hasNoClass = !t.classId || (t.classId && !t.classId._id);
        const isNotFromTeacher = !transferFromTeacher || t._id !== transferFromTeacher._id;
        return hasNoClass && isNotFromTeacher;
    });

    const handleApplyFilters = () => {
        setPg(0);
        if (searchClassId) {
            onSubmit();
        } else {
            getTeacherList();
        }
    };

    const handleResetFilters = () => {
        setSearchClassId('');
        setSearchTerm('');
        setPg(0);
        getTeacherList();
    };

    const toggleViewAddress = (id) => {
        setExpandedAddressId((prev) => (prev === id ? null : id));
    };

    const filteredList = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return teacherList;
        return teacherList.filter((row) => {
            const name = (row.teacherName || '').toLowerCase();
            const cls = (row.classId?.className || '').toLowerCase();
            const sec = (row.sectionId?.sectionName || '').toLowerCase();
            const addr = (row.address || '').toLowerCase();
            return name.includes(term) || cls.includes(term) || sec.includes(term) || addr.includes(term);
        });
    }, [teacherList, searchTerm]);

    const activeTeacherCount = useMemo(
        () => filteredList.filter(isTeacherActive).length,
        [filteredList]
    );
    const inactiveTeacherCount = useMemo(
        () => filteredList.length - activeTeacherCount,
        [filteredList, activeTeacherCount]
    );

    const formik = useFormik({
        initialValues: teacher,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            const isInactive = values.status === 'inactive';
            
            // Show warning alert if status is Inactive
            if (isInactive) {
                const confirmMessage = teacher._id 
                    ? "Warning: Setting teacher status to Inactive will deactivate their login credentials (mobile number and password). They will not be able to log in. Do you want to continue?"
                    : "Warning: Creating teacher with Inactive status means their login credentials (mobile number and password) will be deactivated. They will not be able to log in. Do you want to continue?";
                
                if (!window.confirm(confirmMessage)) {
                    return; // User cancelled, don't submit
                }
            }
            
            const payload = {
                ...values,
                schooleId: userDetails.schooleId,
                status: values.status === 'active',
                classId: values.classId || null,
                sectionId: values.sectionId || null,
            };
            if (teacher._id) {
                payload._id = teacher._id;
                delete payload.password;
                TeacherService.upadeTeacher(payload).then((res) => {
                    handleClose();
                    getTeacherList();
                    resetForm();
                    if (isInactive) {
                        alert("Teacher Updated Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Updated Successfully.");
                    }
                }).catch((err) => {
                    alert(err?.response?.data?.message || err?.response?.data?.error || "Failed to update teacher.");
                });
            }
            else {
                TeacherService.creteTeacher(payload).then((res) => {
                    getTeacherList();
                    resetForm();
                    handleClose();
                    if (isInactive) {
                        alert("Teacher Added Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Added Successfully.");
                    }
                })
                    .catch((err) => {
                        alert(err?.response?.data?.message || "Failed to add teacher.");
                    });
            }
        },
    });

    return (
        <Box className={classes.pageWrapper}>
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Teacher</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Manage teachers, assign classes and sections, and transfer class ownership between teachers.
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    className={classes.primaryBtn}
                    startIcon={<AddIcon />}
                    onClick={() => handleOpen(true)}
                >
                    Add Teacher
                </Button>
            </Box>

            {noteOpen && (
                <Box className={classes.noteBanner}>
                    <Box className={classes.noteIconWrap}>
                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                    </Box>
                    <Box flex={1}>
                        <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
                            Assign Class &amp; Transfer
                        </Typography>
                        <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2, lineHeight: 1.6 }}>
                            <strong>Assign Class</strong> gives a teacher access to additional class/section combinations.
                            <strong> Transfer</strong> moves a primary class from one teacher to another.
                            You can add a teacher without a class and transfer a class to them later.
                            {isSchoolAdmin && (
                                <>
                                    {' '}
                                    <strong>Reset Password</strong> lets you set a new login password for a teacher who forgot it or cannot sign in — enter the new password and share it with the teacher so they can log in to the Teacher app with their mobile number.
                                </>
                            )}
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setNoteOpen(false)}>
                        <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
            )}

            <Card elevation={0} className={classes.filtersCard}>
                <Box className={classes.filtersHeader}>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                        <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>
                            Filters
                        </Typography>
                        {searchClassId && (
                            <Chip size="small" label="Class selected" style={{ backgroundColor: '#eef4ff', color: '#1769d6', fontWeight: 600, height: 22 }} />
                        )}
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <Button size="small" className={classes.resetBtn} onClick={handleResetFilters}>
                            Reset
                        </Button>
                        <Button size="small" variant="contained" className={classes.applyBtn} onClick={handleApplyFilters}>
                            Apply Filters
                        </Button>
                    </Box>
                </Box>
                <Box className={classes.filtersBody}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Typography className={classes.filterLabel}>
                                <SchoolIcon style={{ fontSize: 16, color: '#1769d6' }} />
                                Class
                            </Typography>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <InputLabel id="filter-class-label">All Classes</InputLabel>
                                <Select
                                    labelId="filter-class-label"
                                    name="searchClassId"
                                    label="All Classes"
                                    value={searchClassId}
                                    onChange={(e) => setSearchClassId(e.target.value)}
                                >
                                    <MenuItem value=""><em>All Classes</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Card>

            <Card elevation={0} className={classes.tableCard}>
                <Box className={classes.toolbar}>
                    <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                        {activeTeacherCount} Active Teacher{activeTeacherCount !== 1 ? 's' : ''}
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search teachers…"
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setPg(0); }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} size="small" onClick={getTeacherList}>
                                <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                    <Table stickyHeader size="small" className="dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                {tableHeaders.map((key) => (
                                    <TableCell key={key} className={classes.headCell}>
                                        {key === 'Reset Password' ? (
                                            <Tooltip
                                                title="Set a new login password when a teacher forgot it or cannot access the Teacher app. Click the key icon in each row."
                                                arrow
                                            >
                                                <span style={{ cursor: 'help', borderBottom: '1px dotted #9aa6b6' }}>
                                                    {key}
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            key
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredList.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={tableHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                        No teachers found.
                                    </TableCell>
                                </TableRow>
                            )}
                            {filteredList.slice(pg * rpg, pg * rpg + rpg).flatMap((row) => {
                                const isExpanded = expandedAddressId === row._id;
                                return [
                                    <TableRow key={row._id} hover>
                                        <TableCell>
                                            <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.875rem' }}>
                                                {row.teacherName || '—'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {row.classId?.className ? (
                                                <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={row.classId.className} className={classes.classChip} />
                                            ) : '—'}
                                        </TableCell>
                                        <TableCell>
                                            {row.sectionId?.sectionName ? (
                                                <Chip size="small" label={row.sectionId.sectionName} className={classes.sectionChip} />
                                            ) : '—'}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={isExpanded ? 'Hide address' : 'View address'}>
                                                <IconButton
                                                    className={classes.iconAction}
                                                    size="small"
                                                    onClick={() => toggleViewAddress(row._id)}
                                                >
                                                    {isExpanded ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={isTeacherActive(row) ? 'Active' : 'Inactive'}
                                                className={isTeacherActive(row) ? classes.statusActive : classes.statusInactive}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                className={`${classes.actionBtn} ${classes.assignBtn}`}
                                                startIcon={<AssignmentIndIcon style={{ fontSize: 16 }} />}
                                                onClick={() => openAssignClassDialog(row)}
                                            >
                                                Assign
                                            </Button>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Edit">
                                                <IconButton className={classes.iconAction} size="small" onClick={() => editTeacher(row)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Delete">
                                                <IconButton className={classes.deleteIcon} size="small" onClick={() => deleteTeacher(row)}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {row.classId && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    className={`${classes.actionBtn} ${classes.transferBtn}`}
                                                    startIcon={<SwapHorizIcon style={{ fontSize: 16 }} />}
                                                    onClick={() => openTransferPopup(row)}
                                                >
                                                    Transfer
                                                </Button>
                                            )}
                                        </TableCell>
                                        {isSchoolAdmin && (
                                            <TableCell>
                                                <Tooltip title="Reset teacher login password">
                                                    <IconButton
                                                        className={classes.iconAction}
                                                        size="small"
                                                        onClick={() => openResetPasswordDialog(row)}
                                                    >
                                                        <VpnKeyIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>,
                                    isExpanded ? (
                                        <TableRow key={`${row._id}-address`} className={classes.addressExpandRow}>
                                            <TableCell colSpan={tableHeaders.length}>
                                                <Box className={classes.addressExpandBox}>
                                                    <LocationOnIcon style={{ color: '#1769d6', marginTop: 2, flexShrink: 0 }} />
                                                    <Box>
                                                        <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: '#9aa6b6', textTransform: 'uppercase', marginBottom: 4 }}>
                                                            Address · {row.teacherName || 'Teacher'}
                                                        </Typography>
                                                        <Typography style={{ color: '#0f2d4d', fontSize: '0.9rem', lineHeight: 1.65, whiteSpace: 'pre-wrap' }}>
                                                            {row.address?.trim() || 'No address recorded.'}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ) : null,
                                ].filter(Boolean);
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredList.length}
                    page={pg}
                    onPageChange={(_, p) => setPg(p)}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={(e) => { setRpg(parseInt(e.target.value, 10)); setPg(0); }}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                />

                <Box className={classes.tableStatusFooter}>
                    <Typography className={classes.statusCountLabel}>Status summary:</Typography>
                    <Chip
                        size="small"
                        label={`Active: ${activeTeacherCount}`}
                        className={classes.statusActive}
                    />
                    <Chip
                        size="small"
                        label={`Inactive: ${inactiveTeacherCount}`}
                        className={classes.statusInactive}
                    />
                    <Typography className={classes.statusCountLabel} style={{ marginLeft: 'auto', color: '#9aa6b6' }}>
                        Total shown: {filteredList.length}
                    </Typography>
                </Box>
            </Card>

            <Dialog open={open} onClose={handleClose} scroll="paper" fullWidth maxWidth="xs" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {teacher._id ? 'Edit Teacher' : 'Add Teacher'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                    <DialogContent className={classes.dialogBody}>
                        <Box className={classes.formSection}>
                            <span className={classes.sectionLabel}>Teacher Information</span>
                            <Grid container spacing={1} className={classes.formGrid}>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Teacher Name</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoFocus
                                        autoComplete="off"
                                        id="teacherName"
                                        name="teacherName"
                                        type="text"
                                        value={formik.values.teacherName}
                                        onChange={formik.handleChange}
                                        error={formik.touched.teacherName && Boolean(formik.errors.teacherName)}
                                        helperText={formik.touched.teacherName && formik.errors.teacherName}
                                    />
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Email ID</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={teacher._id ? 12 : 6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Mobile Number</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="mobileNumber"
                                        name="mobileNumber"
                                        type="text"
                                        inputProps={{ maxLength: 10 }}
                                        value={formik.values.mobileNumber}
                                        onChange={formik.handleChange}
                                        error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                        helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                                    />
                                </Grid>
                                {!teacher._id && (
                                    <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                        <span className={classes.fieldLabel}>Set Password</span>
                                        <TextField
                                            fullWidth size="small" variant="outlined"
                                            autoComplete="new-password"
                                            id="password"
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            error={formik.touched.password && Boolean(formik.errors.password)}
                                            helperText={formik.touched.password && formik.errors.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            size="small"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Qualification</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="qualification"
                                        name="qualification"
                                        type="text"
                                        value={formik.values.qualification}
                                        onChange={formik.handleChange}
                                        error={formik.touched.qualification && Boolean(formik.errors.qualification)}
                                        helperText={formik.touched.qualification && formik.errors.qualification}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Address</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="address"
                                        name="address"
                                        placeholder="Enter city name"
                                        type="text"
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        error={formik.touched.address && Boolean(formik.errors.address)}
                                        helperText={formik.touched.address && formik.errors.address}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider />

                        <Box className={classes.formSection} style={{ marginTop: 16, marginBottom: 0 }}>
                            <span className={classes.sectionLabel}>Class &amp; Status</span>
                            <Grid container spacing={1} className={classes.formGrid}>
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Class (Optional)</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        error={formik.touched.classId && Boolean(formik.errors.classId)}
                                    >
                                        <Select
                                            id="demo-simple-select"
                                            name="classId"
                                            displayEmpty
                                            value={formik.values.classId || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                formik.setFieldValue('classId', value);
                                                formik.setFieldValue('sectionId', '');
                                                getSectionListByClass(value);
                                            }}
                                        >
                                            <MenuItem value=""><em>Select Class</em></MenuItem>
                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.classId && formik.errors.classId && (
                                            <FormHelperText>{formik.errors.classId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Section (Optional)</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        disabled={!formik.values.classId || sectionList.length === 0}
                                    >
                                        <Select
                                            id="teacher-section-select"
                                            name="sectionId"
                                            displayEmpty
                                            value={formik.values.sectionId || ''}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value=""><em>All Sections</em></MenuItem>
                                            {sectionList.map(({ _id, sectionName }) => (
                                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Status</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        error={formik.touched.status && Boolean(formik.errors.status)}
                                    >
                                        <Select
                                            id="demo-simple-select-standard"
                                            name="status"
                                            value={formik.values.status === true || formik.values.status === 'active' ? 'active' : 'inactive'}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value="active">Active</MenuItem>
                                            <MenuItem value="inactive">Inactive</MenuItem>
                                        </Select>
                                        {formik.touched.status && formik.errors.status && (
                                            <FormHelperText>{formik.errors.status}</FormHelperText>
                                        )}
                                    </FormControl>
                                    {(formik.values.status === 'inactive' || formik.values.status === false) && (
                                        <span style={{ color: '#ff9800', fontSize: '0.75rem', marginTop: 6, display: 'block', fontWeight: 500 }}>
                                            ⚠️ Warning: Inactive status will deactivate teacher's login credentials (mobile number and password)
                                        </span>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>

                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn}>
                            {teacher._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={assignOpen}
                onClose={handleAssignClose}
                fullWidth
                maxWidth="md"
                PaperProps={{ className: classes.dialogPaperWide }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        Assign Class{assignTeacher ? ` — ${assignTeacher.teacherName}` : ''}
                    </Typography>
                    <IconButton size="small" onClick={handleAssignClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    <Box className={classes.infoBox}>
                        <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.6 }}>
                            When you assign a class or section to this teacher, they will have <strong>create</strong>, <strong>edit</strong>, <strong>delete</strong>, and <strong>read</strong> access for activities and data in those classes.
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" variant="outlined">
                                <InputLabel id="assign-class-label">Class</InputLabel>
                                <Select
                                    labelId="assign-class-label"
                                    id="assign-class"
                                    value={assignClassId}
                                    onChange={handleAssignClassChange}
                                    label="Class"
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {addClassList.map((c) => (
                                        <MenuItem key={c._id} value={c._id}>{c.className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!assignClassId || assignSectionList.length === 0}>
                                <InputLabel id="assign-section-label">Section (optional)</InputLabel>
                                <Select
                                    labelId="assign-section-label"
                                    id="assign-section"
                                    multiple
                                    value={assignSectionIds}
                                    onChange={handleAssignSectionChange}
                                    label="Section (optional)"
                                    renderValue={(selected) => {
                                        const ids = Array.isArray(selected) ? selected : [];
                                        const names = assignSectionList
                                            .filter((s) => ids.includes(s._id))
                                            .map((s) => s.sectionName);
                                        return names.join(', ');
                                    }}
                                >
                                    {assignSectionList.map((s) => (
                                        <MenuItem key={s._id} value={s._id}>
                                            {s.sectionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                size="small"
                                className={classes.saveBtn}
                                onClick={handleAddOrUpdateAssignment}
                            >
                                {assignEditingIndex != null ? 'Update Assignment' : 'Add More Class To Teacher'}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table size="small" className="dashboard-table-row-hover">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.headCell}>Class</TableCell>
                                        <TableCell className={classes.headCell}>Sections</TableCell>
                                        <TableCell className={classes.headCell} align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {assignTeacher && assignTeacher.classId && (
                                        <TableRow>
                                            <TableCell>
                                                {assignTeacher.classId && (assignTeacher.classId.className || assignTeacher.classId)}
                                            </TableCell>
                                            <TableCell>
                                                {assignTeacher.sectionId && (assignTeacher.sectionId.sectionName || assignTeacher.sectionId)
                                                    ? (assignTeacher.sectionId.sectionName || assignTeacher.sectionId)
                                                    : 'No section'}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="caption" style={{ color: '#c62828', fontWeight: 600 }}>
                                                    Primary (not editable)
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {assignments.length === 0 && !assignTeacher?.classId && (
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                <Typography variant="body2" color="textSecondary">
                                                    No additional classes assigned yet.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {assignments.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item.class?.className || ''}</TableCell>
                                            <TableCell>
                                                {item.sectionId && item.sectionId.length > 0
                                                    ? item.sectionId.map((s) => s.sectionName).join(', ')
                                                    : 'No section'}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton size="small" onClick={() => handleEditAssignment(index)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton size="small" onClick={() => handleDeleteAssignment(index)}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    <Button onClick={handleAssignClose} className={classes.cancelBtn}>Cancel</Button>
                    <Button
                        onClick={handleAssignSave}
                        variant="contained"
                        className={classes.saveBtn}
                        disabled={!assignTeacher}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={transferOpen}
                onClose={handleTransferClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: classes.dialogPaper }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        Transfer class to another teacher
                    </Typography>
                    <IconButton size="small" onClick={handleTransferClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    <Box className={classes.infoBox}>
                        <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.6 }}>
                            When you transfer a class, all data (assignments, activities, and related records) for that class will move to the teacher you select below.
                        </Typography>
                    </Box>
                    {transferFromTeacher && (
                        <Typography style={{ marginBottom: 16, color: '#46566b', fontSize: '0.9rem' }}>
                            Transfer class <strong>{transferFromTeacher.classId?.className || ''}</strong> from <strong>{transferFromTeacher.teacherName}</strong> to:
                        </Typography>
                    )}
                    <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel id="transfer-teacher-label">Select teacher (no class assigned)</InputLabel>
                        <Select
                            labelId="transfer-teacher-label"
                            id="transfer-teacher-select"
                            value={transferToTeacherId}
                            onChange={(e) => setTransferToTeacherId(e.target.value)}
                            label="Select teacher (no class assigned)"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {teachersWithoutClass.map((t) => (
                                <MenuItem key={t._id} value={t._id}>{t.teacherName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    <Button onClick={handleTransferClose} className={classes.cancelBtn}>Cancel</Button>
                    <Button
                        onClick={handleTransferSubmit}
                        variant="contained"
                        className={classes.saveBtn}
                        disabled={!transferToTeacherId}
                        startIcon={<SwapHorizIcon />}
                    >
                        Transfer
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={resetPasswordOpen}
                onClose={closeResetPasswordDialog}
                fullWidth
                maxWidth="xs"
                PaperProps={{ className: classes.dialogPaper }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        Reset Password
                    </Typography>
                    <IconButton size="small" onClick={closeResetPasswordDialog}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    {resetPasswordSuccess ? (
                        <Box
                            style={{
                                padding: 16,
                                backgroundColor: '#e6f7ed',
                                borderRadius: 10,
                                border: '1px solid #b7e4c7',
                            }}
                        >
                            <Typography variant="body2" style={{ color: '#1a9b54', fontWeight: 600, lineHeight: 1.6 }}>
                                {resetPasswordSuccess}
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            <Box className={classes.infoBox}>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65 }}>
                                    <strong style={{ color: '#0f2d4d' }}>What is Reset Password?</strong>
                                    <br />
                                    It lets the school admin set a new login password for a teacher&apos;s Teacher app account (linked to their mobile number).
                                </Typography>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65, marginTop: 10 }}>
                                    <strong style={{ color: '#0f2d4d' }}>How to use it</strong>
                                    <br />
                                    Enter a new password below (minimum 6 characters) and click Update Password. Share the new password with the teacher securely. They can sign in with their mobile number and this password.
                                </Typography>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65, marginTop: 10 }}>
                                    <strong style={{ color: '#0f2d4d' }}>Why it is used</strong>
                                    <br />
                                    When a teacher forgets their password, is locked out, or needs credentials restored, you can reset access without removing their account or re-adding them.
                                </Typography>
                            </Box>
                            {resetPasswordTeacher && (
                                <Typography style={{ marginBottom: 16, color: '#46566b', fontSize: '0.9rem' }}>
                                    Set a new login password for <strong>{resetPasswordTeacher.teacherName}</strong>.
                                </Typography>
                            )}
                            <span className={classes.fieldLabel}>New Password</span>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                autoComplete="new-password"
                                type={resetShowPassword ? 'text' : 'password'}
                                value={resetPasswordValue}
                                onChange={(e) => {
                                    setResetPasswordValue(e.target.value);
                                    if (resetPasswordError) setResetPasswordError('');
                                }}
                                error={Boolean(resetPasswordError)}
                                helperText={resetPasswordError || 'Minimum 6 characters'}
                                placeholder="Enter new password"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                size="small"
                                                onClick={() => setResetShowPassword((prev) => !prev)}
                                                edge="end"
                                            >
                                                {resetShowPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    {resetPasswordSuccess ? (
                        <Button
                            onClick={closeResetPasswordDialog}
                            variant="contained"
                            className={classes.saveBtn}
                        >
                            Close
                        </Button>
                    ) : (
                        <>
                            <Button onClick={closeResetPasswordDialog} className={classes.cancelBtn}>
                                Cancel
                            </Button>
                            <Button
                                onClick={handleResetPasswordSubmit}
                                variant="contained"
                                className={classes.saveBtn}
                                disabled={!resetPasswordValue.trim() || resetPasswordSaving}
                                startIcon={<VpnKeyIcon />}
                            >
                                {resetPasswordSaving ? 'Updating…' : 'Update Password'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
